import getExclusionReason from '@app.raytd.com/common/utils/tests/getExclusionReason';
import { toast } from 'sonner';
import { Assessment } from '../assessment/assessment.slice';
import { AssetEntity } from '../asset';
import { TestCase, TestItem, TestSuite } from '../tests/entity';
import type { ReferenceImage, ReferenceImageDisposition } from '../tests/api/referenceImages';
import { TestSpecificationsEntity } from '../tests/test-specifications.slice';
import { UsersEntity } from '../users';
import { transformClassificationTree } from './elementTransformer';
import {
  ActivityItem,
  AddCustomFieldOptionRequest,
  AddCustomFieldOptionResponse,
  ClassificationItem,
  DashboardRecentResponse,
  FastFillUpdateRequest,
  GetTestItemRequest,
  PublishedReportResponse,
  PublishReportPayload,
  PublishReportResponse,
  ReportBlock,
  ReportEntity,
  ReportPayload,
  ReportResponse,
  ReportRevision,
  ReportSection,
  ReportTestItem,
  ReportUpdatePayload,
  ToggleSwitchRequest,
  ToggleSwitchResponse,
  TestItemComment,
} from './types';
import updateItemInReportCache from './updateItemInReportCache';
import {
  NotificationPagination,
  AppNotification,
  ReportExport,
} from '../notifications/types';
import { rAPI } from './rAPI';

export const clientsAPI = rAPI.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getClients: builder.query({
      query: () => 'clients',
      transformResponse: (response: { data: any[] }) => response.data,
    }),

    getClient: builder.query({
      query: (clientId) => `client/${clientId}`,
    }),

    createClient: builder.mutation({
      query: (client) => ({
        url: 'client',
        method: 'POST',
        body: client,
      }),
    }),

    updateClient: builder.mutation({
      query: ({ id, ...client }) => ({
        url: `client/${id}`,
        method: 'PUT',
        body: client,
      }),
    }),

    deleteClient: builder.mutation({
      query: (clientId) => ({
        url: `client/${clientId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetClientsQuery,
  useGetClientQuery,
  useCreateClientMutation,
  useUpdateClientMutation,
  useDeleteClientMutation,
} = clientsAPI;
